/** Avatars shown on a group card before the `+N` overflow (CT-5614, decision for now). */
export const GROUP_CARD_MAX_AVATARS = 2;

/** The group detail loads every member in one page (the mock has no group larger than this). */
export const GROUP_MEMBERS_PAGE_SIZE = 200;

/** Groups grid: as many columns as fit, never narrower than a card (prototype). `min()` keeps phones from overflowing. */
export const GROUPS_GRID_CLASS = 'grid grid-cols-[repeat(auto-fill,minmax(min(300px,100%),1fr))] gap-3';
